export default __webpack_public_path__ + "static/media/no-trades-dark.dd0b73ec.png";